import { __decorate, __metadata } from "tslib";
import { v4 as uuidv4 } from "uuid";
import { Type } from "class-transformer";
import { AddressModel } from "../shared/address";
import { ClientContactModel } from "./clientContact";
let ClientDetailedViewModel = /** @class */ (() => {
    class ClientDetailedViewModel {
        constructor() {
            this.id = uuidv4();
            this.name = "";
            this.description = "";
            this.webSite = "";
            this.linkedIn = "";
            this.twitter = "";
            this.startDate = null;
            this.serviceStatementDate = null;
            this.sowDate = null;
            this.psaDate = null;
            this.phoneNumber = "";
            this.isActive = false;
            this.deactivatedOn = null;
            this.deactivatedReason = null;
            this.clientImageURL = "";
            this.csmId = null;
            this.tsmId = null;
            this.csmName = "";
            this.tsmName = "";
            this.csmImageURL = "";
            this.tsmImageURL = "";
            this.clientContacts = [];
            // @Type(() => PMOTeamModel)
            // teams?: IPMOTeamDTO[] = [];
            this.addresses = [];
        }
    }
    __decorate([
        Type(() => ClientContactModel),
        __metadata("design:type", Array)
    ], ClientDetailedViewModel.prototype, "clientContacts", void 0);
    __decorate([
        Type(() => AddressModel),
        __metadata("design:type", Array)
    ], ClientDetailedViewModel.prototype, "addresses", void 0);
    return ClientDetailedViewModel;
})();
export { ClientDetailedViewModel };
export default class ClientDetailedView extends ClientDetailedViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
